import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  isAuthenticated: false,
};


const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    saveUser: (state, action) => {
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      };
    },
    logoutUser: () => {
      return {
        user: null,
        isAuthenticated: false,
      };
    },

  },
  extraReducers: (builder) => { },
});

export const { saveUser, logoutUser } =
  userSlice.actions;
export default userSlice.reducer;
